import { FormattedMessage } from 'react-intl';

import RecordEntriesNotFoundImage from 'images/record-entries-not-found.svg';

import * as S from './styles';

const RecordEntriesNotFound: React.FC = () => {
  return (
    <S.Container data-testid="recordEntriesNotFound">
      <RecordEntriesNotFoundImage data-testid="notFoundImage" />
      <S.NotFoundMessage data-testid="notFoundMessage">
        <FormattedMessage id="PSYCHOLOGICALRECORD.SUBTITLE.EMPTYSTATE" />
      </S.NotFoundMessage>
    </S.Container>
  );
};

export default RecordEntriesNotFound;
